import client from './client';

export const chatApi = {
  getConversations: () => client.get('/chats'),
  getUnreadCount: () => client.get('/chats/unread-count'),
  getMessages: (partnerId, params) =>
    client.get(`/chat/${partnerId}/messages`, { params }),
  sendMessage: (partnerId, data) =>
    client.post(`/chat/${partnerId}/messages`, data),
  editMessage: (id, content) =>
    client.put(`/chat/messages/${id}/edit`, { content }),
  deleteMessage: (id) => client.delete(`/chat/messages/${id}`),
  markRead: (partnerId) => client.put(`/chat/${partnerId}/read`),
  reactToMessage: (id, emoji) =>
    client.put(`/chat/messages/${id}/react`, { emoji }),
  getLinkPreview: (url) =>
    client.post('/chat/link-preview', { url }),
  exportHistory: (partnerId) =>
    client.get(`/chat/${partnerId}/export`),
};
